export { default, getServerSideProps } from '@views/brands/[brand]';
